// extracted by mini-css-extract-plugin
module.exports = {"sxga0el":"sxga0el","s18a3zoa":"s18a3zoa","spwjkn0":"spwjkn0","son3nom":"son3nom","s6vknvh":"s6vknvh","sloindp":"sloindp","pricing-rotate-sloindp":"pricing-rotate-sloindp"};